import { createAsyncThunk } from '@reduxjs/toolkit';
import { initApplePaySession, InitSessionParams } from '../../services/applePay/initApplePaySession';
import { initApplePaySessionJsSdk } from '../../services/applePay/initApplePaySessionJsSdk';
import { OnClick } from '../../types/ExternalContract';
import { inIframe } from '../../utils/inIframe';
import { onClickHandler } from '../../services/utils/onClickHandler';
import { StoreState } from '../../types/StoreState';
import { selectAuthParams } from '../../selectors';
import { WidgetFedopsLogger } from '../../components/Hoc/Fedops/FedopsProvider';
import { BiLogger } from '../../components/Hoc/BiLogger/BiLoggerProvider';

export interface StartApplePayFlowParams extends InitSessionParams {
  onClick: OnClick;
  biLogger: BiLogger;
  fedopsLogger: WidgetFedopsLogger;
}

export const startApplePayFlow = createAsyncThunk<
  any,
  StartApplePayFlowParams,
  {
    state: StoreState;
  }
>('INIT_APPLE_PAY_SESSION', async (params, thunkAPI) => {
  // if (!window.ApplePaySession) {
  //   return Promise.resolve();
  // }

  // NOTE: temp solution
  // until we will be able to get site name
  // label: paymentLabel,
  // https://wix.slack.com/archives/C016CQ996P5/p1635762905162500
  // also use l18n version when Ecom unlock e-widget version on Product Page
  // params.paymentLabel = t('paymentSheet.total.label');
  params.paymentLabel = 'Store';

  const auth = selectAuthParams(thunkAPI.getState());

  if (inIframe()) {
    return initApplePaySessionJsSdk(params, auth);
  }

  const session = await initApplePaySession(params, auth);

  /*
   * - Apple Pay API doesn't provide onClick callback
   * - We should create ApplePaySession on user gesture, otherwise there will be a delay before session creation and we will see an error:
   *		"InvalidAccessError: Must create a new ApplePaySession from a user gesture handler"
   * So we invoke onClick between session.begin() and user gesture.
   * For initApplePaySessionJsSdk flow this in a Thunderbolt feature-apple-pay TpaHandler
   */
  const { canceled } = await onClickHandler({
    onClick: params.onClick,
    logErrorParams: {
      message: '[ApplePay] this.props.onClick() throws exception',
      fingerprint: ['applePay', 'onClick'],
    },
  })();

  if (canceled) {
    return;
  }

  session.begin();
});
